import {
  PopHistoryStackEntryAction,
  createPopHistoryStackEntryActionCreator,
} from '../history-stack';
import { ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX } from './constants';
import { AdminModalsActionType } from './admin-modals-action-type';

export type PopAdminModal = PopHistoryStackEntryAction<
  AdminModalsActionType.Pop
>;

export const popAdminModal = createPopHistoryStackEntryActionCreator<
  AdminModalsActionType.Pop
>(ADMIN_MODALS_HISTORY_ACTION_TYPE_PREFIX);
